/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export interface SelectedFilters {
  objectType: string | null;
  objectId: string | null;
  statuses: string[];
  tags: string[];
  owners: string[];
}

export interface Filters {
  objectTypes: object[];
  statuses: object[];
  tags: object[];
  owners: object[];
  filterObjects: object[];
}

export const OPTION_ALL = {
  label: 'All',
  value: null,
};

export const OPTION_NONE = {
  label: 'No tags',
  value: null,
};

export const DEFAULT_FILTERS: SelectedFilters = {
  objectType: OPTION_ALL.value,
  objectId: OPTION_ALL.value,
  statuses: [],
  tags: [],
  owners: [],
};
